import { Directive, HostListener, Input, Renderer2, ElementRef, AfterViewInit, inject } from '@angular/core';
import { NgControl } from '@angular/forms';
import { formatPhoneNumber } from '../../constants';

@Directive({ selector: '[appPhoneInputMask]' })
export class PhoneInputMaskDirective implements AfterViewInit {
     ngControl = inject(NgControl);
     private renderer = inject(Renderer2);
     private elem = inject(ElementRef);


     @Input() appPhoneInputMask: boolean;

     ngAfterViewInit(): void {
     	if (this.appPhoneInputMask) {

     		this.renderer.setAttribute(this.elem.nativeElement, 'maxlength', '14');

     		if (!this.elem.nativeElement.hasAttribute('placeholder') || (this.elem.nativeElement.hasAttribute('placeholder') && this.elem.nativeElement.getAttribute('placeholder').length === 0)) {
     			this.renderer.setAttribute(this.elem.nativeElement, 'placeholder', '(xxx) xxx-xxxx');
     		}
     		else {
     			this.renderer.setAttribute(this.elem.nativeElement, 'placeholder', this.elem.nativeElement.getAttribute('placeholder') + ': (xxx) xxx-xxx');
     		}
     	}
     }

     @HostListener('ngModelChange', ['$event'])
     onModelChange(event): void {
     	if (this.appPhoneInputMask) {
     		this.onInputChange(event, false);
     	}
     }

     @HostListener('keydown.backspace', ['$event'])
     keydownBackspace(event): void {
     	if (this.appPhoneInputMask) {
     		this.onInputChange(event.target.value, true);
     	}
     }


     onInputChange(event: string, backspace): void {
     	let newVal = event.replace(/\D/g, '');
     	if (backspace && newVal.length <= 4) {
     		newVal = newVal.substring(0, newVal.length - 1);
     	}

     	newVal = formatPhoneNumber(newVal);

     	this.ngControl.valueAccessor.writeValue(newVal);
     }
}
